/**
 * Sage's bill-of-lading freight term (SO_SalesOrderHeader.UDF_BL): who pays
 * the carrier. Shared by the draft editor, the Edit-in-Sage modal and the
 * read-only order views so the three never disagree on labels or on which
 * terms mean "the customer pays the carrier" (kanban eb79e8dd).
 */

export type BillOfLadingTerm = 'ppd.' | 'col.' | '3rd party';

export const BILL_OF_LADING_OPTIONS: ReadonlyArray<{ value: BillOfLadingTerm; label: string }> = [
  { value: 'ppd.', label: 'Prepaid' },
  { value: 'col.', label: 'Collect' },
  { value: '3rd party', label: '3rd Party' },
];

export const DEFAULT_BILL_OF_LADING: BillOfLadingTerm = 'ppd.';

/** "Prepaid" / "Collect" / "3rd Party"; an unknown or blank term shows as Prepaid (Sage's default). */
export const billOfLadingLabel = (term: string | null | undefined): string =>
  BILL_OF_LADING_OPTIONS.find((o) => o.value === term)?.label ?? 'Prepaid';

/** Collect and 3rd-party BOLs bill the carrier to the customer; ChemMasters never bills freight on them. */
export const customerPaysCarrier = (term: string | null | undefined): boolean =>
  term === 'col.' || term === '3rd party';
